import DefaultMarketWatch from "src/components/feature/MarketWatch";

const Marketwatch = () => {
  return <DefaultMarketWatch />;
};

export default Marketwatch;
